import { createQueryKeys } from '@lukemorales/query-key-factory';
import { UnleashService } from './unleashService';
export const unleashQueries = createQueryKeys('unleash', {
    getStatus: (name, unleashId) => ({
        queryKey: [name, unleashId],
        queryFn: () => UnleashService.getStatus(name, unleashId)
    })
});
